import { Card, CardProps } from "primereact/card";
import React from "react";
import styled from "styled-components";
import { concatClassnames } from "../../utils/util";
import { device } from "../../constants/mediaQueries";
import { useDeviceClassNames } from "../../utils/useDeviceClassNames";

export interface CvpCardProps extends CardProps {
  border?: boolean;
  noPaddingTop?: boolean;
  scollcard?: boolean;
  maxHeight?: boolean;
}

export const CvpCard = (props: CvpCardProps) => {
  const {
    title,
    children,
    border,
    className,
    scollcard,
    maxHeight,
    noPaddingTop,
    ...rest
  } = props;

  const deviceClassNames = useDeviceClassNames();

  return (
    <StyledCvpCard
      title={title}
      className={concatClassnames([
        "cvp-card",
        !!border && "cvp-card-border",

        !!scollcard && "cvp-scrollcard",
        !!maxHeight && "cvp-max-height-card",

        !!noPaddingTop && "no-padding-top",
        className,
        deviceClassNames,
      ])}
      {...rest}
    >
      {children}
    </StyledCvpCard>
  );
};

const PADDING = "1.5rem";
const H_PADDING_LARGE = `calc(${PADDING} * 1.5)`;
const H_PADDING_CHONK = `calc(${PADDING} * 2.25)`;

// sry for the padding xD
const StyledCvpCard = styled(Card)`
  &.cvp-iframe {
    min-height: min(var(--available-content-height), 700px);
  }

  &.cvp-card {
    position: relative;

    .p-card-content:first-child {
      /* If p-card-content is first child then there is no header, 
      so we remove the padding on top of p-card-content */
      padding-top: 0;
    }
  }

  &.cvp-card-border {
    border: 2px solid var(--primary-500);
  }

  &&&.no-padding-top {
    padding-top: 0;
    > .p-card-body {
      padding-top: 0;
    }
  }

  .p-card-body {
    padding: ${PADDING} ${PADDING};
  }

  .p-card-title {
    // We use em on font styles to make them relative to the parent font-size
    // And when we put a heading tag inside a p-card-title, we want the font-size to be relative to 1rem
    font-size: 1rem;
  }

  .p-breadcrumb-list {
    min-height: 1.5rem;
  }

  @media ${device.md} {
    .p-card-body {
      padding: ${PADDING} ${H_PADDING_LARGE};
    }
  }

  @media ${device.chonk} {
    .p-card-body {
      padding: ${PADDING} ${H_PADDING_CHONK};
    }
  }

  &.cvp-max-height-card {
    @media ${device.md} {
      min-height: calc(var(--available-content-height));
    }
  }

  &.cvp-scrollcard {
    .p-card-body {
      padding: 0;
    }

    padding: ${PADDING} 0.5rem;

    @media ${device.md} {
      padding: ${PADDING} 1rem;
    }

    @media ${device.md} {
      padding: ${PADDING} ${H_PADDING_LARGE};
    }

    @media ${device.chonk} {
      padding: ${PADDING} ${H_PADDING_CHONK};
    }

    @media ${device.md} {
      overflow-y: auto;

      min-height: calc(var(--available-content-height) - 1rem);
      max-height: calc(var(--available-content-height) - 1rem);
    }

    //CUSTOM SCROLLBAR

    /* Styles the scrollbar itself (the handle) */
    ::-webkit-scrollbar {
      width: 0.6rem; /* scrollbar width */
      height: 0.6rem; /* scrollbar height for horizontal scrollbars */
    }

    /* Styles the part of the scrollbar track (part the handle slides within) */
    ::-webkit-scrollbar-track {
      background-color: transparent; /* track background color */
    }

    /* Styles the draggable part of the scrollbar */
    ::-webkit-scrollbar-thumb {
      background-color: var(--primary-500); /* thumb color */
      border-radius: 4px; /* rounded corners for the thumb */
      border: 2px solid transparent; /* optional: border around the thumb */
      background-clip: content-box; /* avoids coloring the border */
    }

    /* Additional styles for Firefox */
    * {
      scrollbar-width: thin;
      scrollbar-color: var(--primary-500) transparent;
    }
  }
`;

export const CvpCardPadding = styled.div`
  padding-top: ${PADDING};
  padding-bottom: ${PADDING};
`;
